/** Subdomains that use Auto Services branding (logo, copy, etc.). */
const AUTO_SERVICES_SUBDOMAINS = new Set([
  "autoservices",
  "autoservice",
  "auto-services",
]);

/** Logo URLs used for tenant-specific header/login branding */
export const TENANT_BRANDING_LOGOS = {
  autoServices:
    "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg",
  eurorepar:
    "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearelogo.png",
} as const;

/** First label of `window.location.hostname` (subdomain in production). */
export function getTenantSubdomain(): string {
  if (typeof window === "undefined") return "";
  const first = window.location.hostname.split(".")[0];
  return first ?? "";
}

/**
 * True when the first hostname label is an Auto Services tenant.
 * Comparison is case-insensitive so `AutoServices` still matches.
 */
export function isAutoServicesTenant(
  subdomain: string | undefined | null
): boolean {
  if (subdomain == null || subdomain === "") return false;
  return AUTO_SERVICES_SUBDOMAINS.has(subdomain.toLowerCase());
}
